const team = {
  invitations: {
    accept: {
      missingInfo: 'Dieser Einladungslink enthält nicht alle erforderlichen Informationen.',
      defaultError: 'Einladung nicht gefunden oder nicht mehr verfügbar.',
      toastAcceptError: 'Einladung konnte nicht angenommen werden.',
      toastDeclineError: 'Einladung konnte nicht abgelehnt werden.',
      issueBadge: 'Einladungsproblem',
      errorHeading: 'Diese Einladung konnte nicht geöffnet werden',
      errorFollowup: 'Wende dich an den Workspace-Inhaber und bitte um einen neuen Link, falls du einen Fehler vermutest.',
      errorAlert:
        'Einladungs-Token laufen ab oder werden ungültig, sobald sie genutzt wurden. Bitte den Team-Inhaber, eine neue Einladung zu senden, und prüfe, ob du die aktuellste E-Mail verwendest.',
      checkingTitle: 'Einladung wird geprüft…',
      checkingSubtitle: 'Wir überprüfen Workspace und Berechtigungen für diesen Link.',
      invitationBadge: 'Einladung',
      joinHeading: 'Workspace {{team}} beitreten',
      joinSubtitle:
        'Tritt dem gemeinsamen Workspace {{workspace}} bei. Durch die Annahme der Einladung erhältst du Zugriff auf geteilte Plätze, Billing-Einblicke und Automations-Tools.',
      roleLabel: 'Rolle',
      roleNote:
        'Du startest mit den Berechtigungen, die dein Workspace-Inhaber festgelegt hat. Nach der Anmeldung kannst du dein Profil anpassen.',
      expiresLabel: 'Einladung läuft ab',
      confirmBy: 'Bitte bis {{date}} bestätigen, um deinen reservierten Platz zu behalten.',
      confirmSoon: 'Bitte zeitnah bestätigen, um deinen reservierten Platz zu behalten.',
      workspaceFallback: 'deinem Workspace',
      timeSoon: 'bald',
      detailsHeading: 'Einladungsdetails',
      sentTo: 'Gesendet an {{email}}',
      sentBy: 'von {{name}}',
      sentOn: 'am {{date}}',
      workspaceLabel: 'Workspace',
      teamLabel: 'Team',
      statusLabel: 'Status',
      emailOnFileLabel: 'Hinterlegte E-Mail',
      confirmEmailNote:
        'Bestätige die E-Mail-Adresse, mit der du diesem Workspace beitreten möchtest. Wir gleichen sie vor der Aktivierung mit der Einladung ab.',
      emailLabel: 'Deine E-Mail',
      emailPlaceholder: 'du@example.com',
      emailNote: 'Wir prüfen diese E-Mail, bevor wir die Aktion abschließen.',
      confirmationNotice: 'Die Bestätigung wird an {{email}} gesendet.',
      invitedBy: 'Eingeladen von {{name}}.',
      seatProvided: 'Platz wurde vom Workspace-Inhaber bereitgestellt.',
      expiresOn: 'Läuft am {{date}} ab.',
      declinedAlert:
        'Du hast diese Einladung abgelehnt. Du kannst diesen Tab schließen oder den Workspace-Inhaber kontaktieren, falls du es dir anders überlegst.',
      acceptCta: 'Einladung annehmen',
      accepting: 'Wird angenommen…',
      declineCta: 'Ablehnen',
      cancelDecline: 'Ablehnung abbrechen',
      declinePrompt: 'Teile dem Team optional mit, warum du absagst',
      declinePlaceholder: 'Ich nehme an diesem Projekt aktuell nicht teil…',
      sendDecline: 'Ablehnung senden',
      declining: 'Wird abgelehnt…',
      declineNote: 'Wir benachrichtigen den Workspace-Inhaber sofort.',
    },
  },
} as const

export default team
